@file:OptIn(InternalResourceApi::class)

package waifupics.modules.core.core_ui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/waifupics.modules.core.core_ui.generated.resources/"

@delegate:ResourceContentHash(-1_572_745_204)
internal val Res.drawable.favicon: DrawableResource by lazy {
      DrawableResource("drawable:favicon", setOf(
        ResourceItem(setOf(), "${MD}drawable/favicon.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_246_727_374)
internal val Res.drawable.ic_app: DrawableResource by lazy {
      DrawableResource("drawable:ic_app", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_app.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-90_383_969)
internal val Res.drawable.ic_launcher: DrawableResource by lazy {
      DrawableResource("drawable:ic_launcher", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_launcher.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_269_302_106)
internal val Res.drawable.ic_launcher_background: DrawableResource by lazy {
      DrawableResource("drawable:ic_launcher_background", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_launcher_background.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_687_323_086)
internal val Res.drawable.ic_launcher_foreground: DrawableResource by lazy {
      DrawableResource("drawable:ic_launcher_foreground", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_launcher_foreground.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-900_363_588)
internal val Res.drawable.ic_warning: DrawableResource by lazy {
      DrawableResource("drawable:ic_warning", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_warning.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("favicon", Res.drawable.favicon)
  map.put("ic_app", Res.drawable.ic_app)
  map.put("ic_launcher", Res.drawable.ic_launcher)
  map.put("ic_launcher_background", Res.drawable.ic_launcher_background)
  map.put("ic_launcher_foreground", Res.drawable.ic_launcher_foreground)
  map.put("ic_warning", Res.drawable.ic_warning)
}
